import { PayloadAction } from '@reduxjs/toolkit';
import { AccessoryState } from '../models';

export const deleteAccessory = (
  state: AccessoryState<any, any>,
  action: PayloadAction<{ section_id: number; id: number }>
) => {
  if (!state.accessories[action.payload.section_id]) return;
  delete state.accessories[action.payload.section_id][action.payload.id];
};
